












on_clickaway = require('vue-clickaway')
exports.default =
  mixins: [ on_clickaway.mixin ]
  props:
    filter_item_selected_ids:
      type: Array
      default: -> []

    uncheck_all_items:
      type: Boolean
      default: false

    default_label:
      type: String
      default: ''

    integration:
      type: String
      default: ''

  data: ->
    selected_items: []
    list: []
    show_list: false

  computed:
    dropdown_title: ->
      switch
        when @list.filter((s) -> s.selected == true ).length == 0 then @default_label || this.$t('integrations.label.stages_matching.selectPhases')
        when @list.filter((s) -> s.selected == true ).length == 1 then @list.filter((s) -> s.selected == true )[0].text
        else this.$t('integrations.label.stages_matching.multipleStages')

  methods:
    updateStages: ->
      @$emit 'item-selected-items', @list.filter((s) -> s.selected ).map((s) -> s.value )

    clickList: ->
      @show_list = !@show_list

    clicked: (data)->
      for stage in @list
        if stage.value == data.value
          if stage.selected
            stage.selected = !stage.selected
          else
            stage.selected = true
      @updateStages()

    onClickaway: ->
      if @show_list
        @show_list = false

  created: ->
    if @integration.indexOf('hubspot_integration') > -1
      @list = new Contact().hubspot_stages()
    else if @integration.indexOf('rd_station') > -1
      @list = new Contact().rd_station_stages()
    else
      @list = new Contact().stages()

    if  ['webhook', 'nectar', 'hubspot', 'pipedrive'].indexOf(@integration.toLowerCase()) > -1
      @list.push({ value: 'lost', selected: false, text: this.$t('integrations.label.stages_matching.lost') })

    for stage in @list
      if @filter_item_selected_ids.indexOf(stage.value) > -1
        stage.selected = true



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/dropdown_multiple_kind/stage_filter.vue